module.exports = __webpack_public_path__ + "static/media/mimi2.82a78335.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mimi2.gif
// module id = 295
// module chunks = 0